module.exports = __webpack_public_path__ + "layout_com7.jpg?8e8ade323b3fd2595790d19e4a28f59e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com7.jpg
// module id = 87
// module chunks = 0